import { createContext, useState, useEffect } from "react";
import getCountries from "../services/getCountries";
import getDepartments from "../services/getDepartments";
import getProvinces from "../services/getProvinces";
import getLocalities from "../services/getLocalities";
import getCensusLocalities from "../services/getCensusLocalities";
import getMunicipalities from "../services/getMunicipalities";

const LocationContext = createContext();

const LocationProvider = ({ children }) => {
  const [countries, setCountries] = useState([]);
  const [provinces, setProvinces] = useState([]);
  const [departments, setDepartments] = useState([]); //
  const [localities, setLocalities] = useState([]); //
  const [censusLocalities, setCensusLocalities] = useState([]); //
  const [municipalities, setMunicipalities] = useState([]); //

  useEffect(() => {
    getCountries().then((resp) => setCountries(resp));
    getProvinces().then((resp) => setProvinces(resp));
    getDepartments().then((resp) => setDepartments(resp));
    getLocalities().then((resp) => setLocalities(resp));
    getCensusLocalities().then((resp) => setCensusLocalities(resp));
    getMunicipalities().then((resp) => setMunicipalities(resp));
  }, []);

  const searchLocalidades = (prov_id) => {
    var concatLocalidades = [];
    const filteredDepartments = departments.department?.filter(
      (department) => department.department_province_id === prov_id
    );

    filteredDepartments.map((dep) =>
      concatLocalidades.push({
        locality_id: dep.department_id,
        locality_name: dep.department_name,
        locality_full_name: dep.department_full_name,
        locality_province_id: dep.department_province_id,
        localitie_type: "departments",
      })
    );

    const filteredLocalities = localities.locality?.filter(
      (locality) => locality.localities_province_id === prov_id
    );

    filteredLocalities.map((locality) =>
      concatLocalidades.push({
        locality_id: locality.localities_id,
        locality_name: locality.localities_name,
        locality_full_name: null,
        locality_province_id: locality.localities_province_id,
        localitie_type: "localities",
      })
    );

    const filteredMunicipalities = municipalities.municipality?.filter(
      (municipality) => municipality.municipality_province_id === prov_id
    );

    filteredMunicipalities.map((municipality) =>
      concatLocalidades.push({
        locality_id: municipality.municipality_id,
        locality_name: municipality.municipality_name,
        locality_full_name: municipality.municipality_fullname,
        locality_province_id: municipality.municipality_province_id,
        localitie_type: "municipalities",
      })
    );

    const filteredCensusLoc = censusLocalities.censusLocality?.filter(
        (censusLoc) => censusLoc.census_localities_province_id === prov_id
      );

      filteredCensusLoc.map((censusLoc) =>
      concatLocalidades.push({
        locality_id: censusLoc.census_localities_id,
        locality_name: censusLoc.census_localities_name,
        locality_full_name: null,
        locality_province_id: censusLoc.census_localities_province_id,
        localitie_type: "census_localities",
      })
    );

    concatLocalidades.sort((a,b) => {
        return a.locality_name.localeCompare(b.locality_name);
    });

    return concatLocalidades
  };

  return (
    <LocationContext.Provider
      value={{
        countries,
        provinces,
        searchLocalidades,
      }}
    >
      {children}
    </LocationContext.Provider>
  );
};

export { LocationProvider };

export default LocationContext;
